// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-card__title[data-v-739da435] {
  padding-bottom: 0;
}
.v-card[data-v-739da435] {
  box-shadow: none;
  height: 100% !important;
}
.policy-information .v-card__text[data-v-739da435],
.policy-information .v-card__title[data-v-739da435] {
  flex: 0 0 auto;
}
.flex[data-v-739da435] {
  background-color: #ffffff;
  border-radius: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.flex[data-v-739da435]:nth-child(3) {
  border-right: 0;
}
pre[data-v-739da435] {
  font-family: inherit;
  font-weight: 600;
  white-space: inherit;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
